<template>
  <div>
    <div v-show="false">
      <ShippingEligibilityInfo ref="eligibility" />
    </div>
    <div
        v-loading="loading"
        class="choose-one-off flex flex-auto flex-col">
      <div class="title">
        Choose the one-off item
      </div>
      <div class="description">
        Please search and select the item you would like to process as one-off.
      </div>

      <div>
        <el-input
            v-model="searchedValue"
            type="text"
            placeholder="Search"
            class="one_off_search_box"
            clearable />
      </div>
      <div>
        <div
            v-if="noResultFound"
            style=" display: flex; padding: 16px 24px; ">
          <div
              class="error-msg"
              style="width: 987px; display: flex; align-items: center; justify-content: center;height: 84px;border: 1px solid #DEE5EC; color: #81919F; font-feature-settings: 'clig' off, 'liga' off;">
            No devices matching your search request found. Please try another one.
          </div>
        </div>
        <div>
          <div
              style="overflow-y: scroll; height: 600px;">
            <div
                v-for="item in searchedItems"
                :key="item.id"
                v-bind="item">
              <div
                  v-loading="item.ux_properties.loading"
                  class="one-off-items-view">
                <el-card
                    class="item-card"
                    :class="{'highlighted-item-card' : item.selected}">
                  <div
                      style="display: flex; justify-content: space-between;">
                    <div style="display: flex; justify-content: flex-start">
                      <div
                          v-if="productRestricted(item)"
                          style="position: absolute; right: 0">
                        <span
                            v-if="expedited"
                            class="expedited item">Expedited</span>
                        <span class="shipping-restrictions-label">Shipping Restrictions Apply</span>
                      </div>
                      <div
                          class="item-image">
                        <DeviceImage
                            :device="item" />
                      </div>
                      <div
                          style="margin-left: 8px"
                          class="item-content">
                        <div class="item-name">
                          {{ item.product.description }} – Stock {{ item.stock }}
                        </div>
                        <div class="item-color">
                          {{ item.color }}
                        </div>
                        <div
                            v-if="item.estimated_delivery"
                            class="estimated-delivery">
                          {{ item.estimated_delivery }}
                        </div>
                      </div>
                    </div>
                    <div class="one_off_radio_btn">
                      <input
                          v-model="selectedDevice"
                          :value="item"
                          type="radio"
                          name="options"
                          :disabled="productRestricted(item)"
                          style="margin-right: 16px; border-radius: 4px; width: 24px; height: 24px; align-self: center; accent-color: #1998D5;"
                          @change="productChanged(item)">
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { createNamespacedHelpers as h } from "vuex";
import { get, isEmpty, take, remove } from "lodash";
import ShippingEligibilityInfo from "../../../CustomerRequest/CustomerRequestComponents/ShippingEligibilityInfo";
import DeviceImage from "../../../../components/Shared/DeviceImage.vue";
import deliveryEstimates from "@/mixins/deliveryEstimates";
import axios from "axios";

const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");
export default {
  name: "ChooseOneOff",
  components: { ShippingEligibilityInfo, DeviceImage },
  mixins: [deliveryEstimates],
  props: {
    selectedItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    country: {
      type: String,
      default: "",
    },
    state: {
      type: String,
      default: "",
    },
    zipCode: {
      type: String,
      default: "",
    },
    expedited: {
      type: Boolean,
      default: false,
    },
    oneOffSearch: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedDevice: {},
      searchedValue: this.oneOffSearch || "",
      loading: false,
      restrictedProducts: [],
      displayableItems: [],
      variants: [],
    };
  },
  computed: {
    ...sharedGetters(["reasons", "groups"]),
    searchedItems() {
      if (!this.searchedValue.length) {
        return this.displayableItems;
      }
      return this.displayableItems.filter(
        (item) =>
          get(item, "product.description", "")
            .toLowerCase()
            .includes(this.searchedValue.toLowerCase()) ||
          get(item, "type", "")
            .toLowerCase()
            .includes(this.searchedValue.toLowerCase())
      );
    },
    noResultFound() {
      return this.searchedValue.length > 0 && this.searchedItems.length === 0;
    },
  },
  mounted() {
    this.getVariantsByCountry(() => {
      const selectedDevice = remove(
        this.displayableItems,
        (e) => e.id === this.selectedItem.id
      );

      if (selectedDevice.length > 0) {
        // put the selected device in the first position of the list
        this.displayableItems = [
          selectedDevice[0],
          ...this.sortDisplayableItems(this.displayableItems),
        ];
        this.productShippingEligibility(selectedDevice[0]);
      }
    });
  },
  methods: {
    productRestricted(device) {
      return (
        this.restrictedProducts.includes(device.product.kind) ||
        !device.product.enabled
      );
    },
    productChanged(variant) {
      this.productShippingEligibility(variant);
    },
    productShippingEligibility(variant) {
      let productKind = variant.product.kind;
      if (isEmpty(productKind)) return;
      let country_code = this.country;
      let state_code = this.state;
      this.$set(variant.ux_properties, "loading", true);
      this.$refs.eligibility
        .evaluate({
          product_kinds: [productKind],
          country_code,
          state_code,
          expedited: this.expedited,
        })
        .then((isEligible) => {
          this.displayableItems
            .filter((e) => e.type === productKind)
            .forEach((e) => this.$set(e, "shipping_eligible", isEligible));

          if (!isEligible) {
            this.selectedDevice = {};
            this.$emit("update:selected-item", this.selectedDevice);
            this.restrictedProducts.push(productKind);
            this.$notify({
              title: "Warning",
              message: `${
                this.expedited ? "Expedited " : ""
              }Shipping Restrictions Apply!`,
              type: "warning",
              duration: 6000,
            });
          } else {
            this.setNewDevice(variant);
          }
        })
        .finally(() => {
          this.$set(variant.ux_properties, "loading", false);
          this.$forceUpdate();
        });
    },
    enabledProducts() {
      return this.variants.filter(
        (p) => p.product != null && p.product.enabled
      );
    },
    sortDisplayableItems(items) {
      return items.sort((a, b) => {
        const nameA =
          get(a, "product.description", "").toLowerCase() +
          get(a, "stock", "").toLowerCase();
        const nameB =
          get(b, "product.description", "").toLowerCase() +
          get(b, "stock", "").toLowerCase();
        return nameA.localeCompare(nameB);
      });
    },
    setNewDevice(newDevice) {
      if (this.selectedDevice) {
        this.displayableItems.forEach((element) => {
          element.selected = element.id === newDevice.id;
        });
      }
      newDevice.selected = true;
      newDevice.ux_properties = { loading: false };
      this.selectedDevice = newDevice;
      this.$emit("update:selected-item", this.selectedDevice);
      this.$emit("update:one-off-search", this.searchedValue);
    },
    getVariantsByCountry(callback) {
      this.loading = true;
      axios
        .get(`/v3/orders/load_variants_by_country`, {
          params: { country: this.country },
        })
        .then((response) => {
          this.variants = response.data.variants;
          const products = this.enabledProducts();
          products.forEach((element) => {
            element.ux_properties = { loading: false };
            element.type = element.product.kind;
            element.selected = element.id === this.selectedItem.id;
          });

          this.displayableItems = this.sortDisplayableItems(products);
          this.fetchDeliveryEstimates({
            country: this.country,
            postalCode: this.zipCode,
            items: this.displayableItems,
            priorityItems: this.displayableItems.slice(0, 10),
          });
          callback();
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            title: "Error",
            message:
              error.data.message !== undefined
                ? error.data.message
                : "Something went wrong! Try again.",
            type: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss">
.choose-one-off {
  .title {
    margin-bottom: 8px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #424242;
    align-self: stretch;
  }

  .description {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    color: #424242;
    align-self: stretch;
    margin-bottom: 8px;
  }
  .one_off_search_box {
    margin-top: 16px;
    display: flex;
    width: 375px;
    padding: 12px 60px;
    background: white url("../../../../assets/find.svg") no-repeat 16px;
    background-size: 25px 25px;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #81919f;
  }
  .one_off_search_box:focus-within {
    border: 1px solid #1998d5;
  }
  .one_off_search_box input {
    border: none;
  }
  .one_off_search_box img {
    position: absolute;
    top: 2px;
    right: 5px;
    width: 10px;
    height: 10px;
  }
  .one_off_search_box.el-input {
    width: 245px !important;
    height: 22px !important;
  }
  input.el-input__inner {
    width: 263px !important;
    height: 24px !important;
    padding: 0px !important;
  }
  .item-name {
    height: 24px;
    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #424242;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 15px;
  }

  .item-color {
    height: 24px;
    font-family: "Equip", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 2px;
  }
  .estimated-delivery {
    color: var(--light-content-backup, #6e6e6e);
    font-family: Equip;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .one-off-items-view {
    .item-card {
      margin: 8px 0px 8px 0px !important;
      padding: 8px !important;
      box-shadow: none !important;
      .el-card__body {
        margin: 0px !important;
        position: relative;
      }
    }
    .shipping-restrictions-label {
      display: inline-block;
      background-color: #fdf6ec;
      color: #ff8c00;
      font-size: 0.8em;
      padding: 3px 10px;
      border-radius: 3px;
      border: 1px solid #faecd8;
      &.item {
        margin: 0;
      }
    }
    .expedited {
      @extend .shipping-restrictions-label;
      color: $--color-primary;
      background-color: lighten($--color-primary, 50%);
      margin: 1rem 0 1rem;
    }

    .item-image {
      height: 80px;
      width: 80px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .highlighted-item-card {
      background: #eff8fc;
      border: 2px solid #1998d5;
      border-radius: 4px;
    }
    .one_off_radio_btn {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
